export default __webpack_public_path__ + "static/media/CNo.40-0.1d4df172.jpg";